import { WebErrorCodes } from "../../../../../../../utProto/webEnums_pb"

export const DURATION_PERIOD_VALUES = {
    ONE_DAY: 1,
    SEVEN_DAYS: 3,
    ONE_MONTH: 3,
    THREE_MONTHS: 3,
    SIX_MONTHS: 6,
    ONE_YEAR: 12,
    TWO_YEARS: 24,
    THREE_YEARS: 36,
    CUSTOM: 3,
}

export const DURATION_PERIOD_LABELS = {
    ONE_DAY: 'Current Day',
    SEVEN_DAYS: 'Last 7 Days',
    ONE_MONTH: 'Last 1 Month',
    THREE_MONTHS: 'Last 3 Months',
    SIX_MONTHS: 'Last 6 Months',
    ONE_YEAR: 'Last 1 Year',
    TWO_YEARS: 'Last 2 Years',
    THREE_YEARS: 'Last 3 Years',
    CUSTOM: 'Custom'
}

export const DURATION_PERIOD = [
    { value: DURATION_PERIOD_VALUES.SEVEN_DAYS, label: DURATION_PERIOD_LABELS.SEVEN_DAYS },
    { value: DURATION_PERIOD_VALUES.ONE_MONTH, label: DURATION_PERIOD_LABELS.ONE_MONTH },
    { value: DURATION_PERIOD_VALUES.ONE_YEAR, label: DURATION_PERIOD_LABELS.ONE_YEAR },
    { value: DURATION_PERIOD_VALUES.TWO_YEARS, label: DURATION_PERIOD_LABELS.TWO_YEARS },
    { value: DURATION_PERIOD_VALUES.THREE_YEARS, label: DURATION_PERIOD_LABELS.THREE_YEARS },
    { value: DURATION_PERIOD_VALUES.CUSTOM, label: DURATION_PERIOD_LABELS.CUSTOM }
]

export const DURATION_PERIOD_SWASTIKA = [
    { value: DURATION_PERIOD_VALUES.SEVEN_DAYS, label: DURATION_PERIOD_LABELS.SEVEN_DAYS },
    { value: DURATION_PERIOD_VALUES.ONE_MONTH, label: DURATION_PERIOD_LABELS.ONE_MONTH },
    { value: DURATION_PERIOD_VALUES.THREE_MONTHS, label: DURATION_PERIOD_LABELS.THREE_MONTHS },
    { value: DURATION_PERIOD_VALUES.SIX_MONTHS, label: DURATION_PERIOD_LABELS.SIX_MONTHS },
    { value: DURATION_PERIOD_VALUES.ONE_YEAR, label: DURATION_PERIOD_LABELS.ONE_YEAR },
    { value: DURATION_PERIOD_VALUES.TWO_YEARS, label: DURATION_PERIOD_LABELS.TWO_YEARS },
    { value: DURATION_PERIOD_VALUES.THREE_YEARS, label: DURATION_PERIOD_LABELS.THREE_YEARS },
    { value: DURATION_PERIOD_VALUES.CUSTOM, label: DURATION_PERIOD_LABELS.CUSTOM }
]

export const BACKTEST_ERR_CODES: number[] = [
    WebErrorCodes.WEBERRORCODES_MAXBACKTESTALLOWEDINAMONTH,
    WebErrorCodes.WEBERRORCODES_MAXBACKTESTALLOWEDPERDAY,
    WebErrorCodes.WEBERRORCODES_BACKTESTALLOWEDFORMONTHS,
    WebErrorCodes.WEBERRORCODES_BACKTESTINGNOTALLOWED
]